import React, {useEffect, useRef, useState} from 'react'
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import { useDispatch, useSelector } from 'react-redux'
import { useStore } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { useQuery } from '../../../../../hooks/common'
import { FormattedMessage, useIntl } from 'react-intl'
import { updateCustomerSave } from '../../../../../../api'
// import Toast from '../../../../../components/toast'
import { BigButton } from '../../../../../components/button'
import MeChildHeader from '../../../components/me-child-header'
import MeLoading from '../../../components/loading'
import { action_fetch_customer } from '../../../../../../store/actions/pages/customer'

const SetName = props => {
    useStyles(classes)
    const [loading, setLoading] = useState(false)
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const store = useStore()
    const params = useParams()
    const query = useQuery()
    const history = useHistory()
    const Intl = useIntl()
    const dispatch = useDispatch()

    const pageCustomer = useSelector(state => state.pageCustomer)
    const {customer} = pageCustomer || {}
    const {name} = customer || {}

    useEffect(async () => {
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
			await SetName.fetchData(store, params, query)
		}
    }, [customer?.id])

    useEffect(() => {
        if(customer?.id){
            setLoading(false)
        } else {
            setTimeout(() => {
                setLoading(false)
            }, 5000)
        }
    },[customer])

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
        if(name?.firstName){
            setFirstName(name?.firstName)
        }
        if(name?.lastName){
            setLastName(name?.lastName)
        }
    }, [name])

    const saveHandle = async () => {
        setLoading(true)
        let params = {
            customer:{
                name: {
                    firstName: firstName,
                    lastName: lastName
                }
            },
            name: 'name'
        }
        const response = await updateCustomerSave(params)
        setLoading(false)
        if(response?.code == 200){
            await dispatch(action_fetch_customer())
            history.goBack()
        } else {
            setLoading(false)
            alert(response?.result || response)
        }
    }

    return (
        <div className={classes.SetNamePage}>
            <MeChildHeader name={Intl.formatMessage({id: 'name'})}/>

            <div className={classes.SetForm}>
                <div>
                    <input
                        maxLength={50}
                        type="text"
                        name="firstName"
                        autoComplete="off"
                        placeholder={Intl.formatMessage({id: 'first_name'})}
                        value={firstName}
                        onChange={(e) => {
                            setFirstName(e?.target?.value)
                        }}
                    />
                </div>

                <div>
                    <input
                        maxLength={50}
                        type="text"
                        name="lastName"
                        autoComplete="off"
                        placeholder={Intl.formatMessage({id: 'last_name'})}
                        value={lastName}
                        onChange={(e) => {
                            setLastName(e?.target?.value)
                        }}
                    />
                </div>
            </div>

            <div className={classes.SignOutButton}>
                <BigButton onClick={saveHandle}><FormattedMessage id="save" defaultMessage="Save"/></BigButton>
            </div>

            <MeLoading loading={loading}/>
        </div>
    )
}


SetName.fetchData = async (store, params, search, headers) => {
}

export default SetName